"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GLOBAL_COMPOSITE_OPERATIONS = void 0;
var GLOBAL_COMPOSITE_OPERATIONS = [{
  value: 'source-over',
  label: 'Нормальный'
}, {
  value: 'multiply',
  label: 'Умножение'
}, {
  value: 'screen',
  label: 'Осветление'
}, {
  value: 'overlay',
  label: 'Перекрытие'
}, {
  value: 'darken',
  label: 'Замена темным'
}, {
  value: 'lighten',
  label: 'Замена светлым'
}, {
  value: 'color-dodge',
  label: 'Осветление основы'
}, {
  value: 'color-burn',
  label: 'Затемнение основы'
}, {
  value: 'hard-light',
  label: 'Жесткий свет'
}, {
  value: 'soft-light',
  label: 'Мягкий свет'
}, {
  value: 'difference',
  label: 'Разница'
}, {
  value: 'exclusion',
  label: 'Исключение'
}, {
  value: 'hue',
  label: 'Цветовой тон'
}, {
  value: 'saturation',
  label: 'Насыщенность'
}, {
  value: 'color',
  label: 'Цветность'
}, {
  value: 'luminosity',
  label: 'Свечение'
}];
exports.GLOBAL_COMPOSITE_OPERATIONS = GLOBAL_COMPOSITE_OPERATIONS;